import styled from 'styled-components';
import { device } from '../../styles/stylesheets'
import { ContainerShadowStyled } from '../ContainerShadowStyled';

export const Container = styled(ContainerShadowStyled)`
  float: left;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  height: 116px;
  margin: 12px;
  cursor: pointer;
  @media ${device.fromLaptopL} {
    width: calc(20% - 24px);
  }
  @media ${device.untilLaptopL} {
    width: calc(25% - 24px);
  }
  @media ${device.untilLaptop} {
    width: calc(33% - 24px);
  }
  @media ${device.untilTablet} {
    width: calc(50% - 24px);
  }
`;

export const ServiceText = styled.div`
  font-size: 12px;
  line-height: 16px;
`;

export const ImageService = styled.img`
  margin: 16px;
  width: 48px;
  height: 48px;
`;
